import type { TFunction } from 'i18next';
import type { NavMainProps } from './main/nav/types';

import { PUBLIC_PATH } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export const createNavData = (t: TFunction<'public'>): NavMainProps['data'] => [
  {
    title: t('nav.home'),
    icon: <Iconify icon="eva:home-fill" />,
    path: '/',
  },
  {
    title: t('nav.appInfo'),
    icon: <Iconify icon="ic:round-grain" />,
    path: PUBLIC_PATH.appInfo,
  },
  {
    title: t('nav.notice'),
    icon: <Iconify icon="mdi:bullhorn" />,
    path: PUBLIC_PATH.board.root,
  },
  {
    title: t('nav.inquiry'),
    icon: <Iconify icon="mdi:message-text-outline" />,
    path: PUBLIC_PATH.inquiry,
  },
  {
    title: t('nav.feedSearch'),
    icon: <Iconify icon="mdi:food-variant" />,
    path: PUBLIC_PATH.feed.search,
  },
];

export const navData: NavMainProps['data'] = [
  {
    title: '바라봄소개',
    icon: <Iconify icon="eva:home-fill" />,
    path: '/',
  },
  {
    title: '데이터센터',
    icon: <Iconify icon="ic:round-grain" />,
    path: PUBLIC_PATH.appInfo,
  },
  {
    title: '공지사항',
    icon: <Iconify icon="mdi:bullhorn" />,
    path: PUBLIC_PATH.board.root,
  },
  {
    title: '문의하기',
    icon: <Iconify icon="mdi:message-text-outline" />,
    path: PUBLIC_PATH.inquiry,
  },
  {
    title: '사료검색',
    icon: <Iconify icon="mdi:food-variant" />,
    path: PUBLIC_PATH.feed.search,
  },
];
